// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"569":"1528d5cc","703":"fb7a0e99"}[chunkId] + ".chunk.js";
};